<template>
  <nav class="flex items-center justify-between flex-wrap py-6 h-20">
    <div class="flex items-center flex-shrink-0 text-white pl-6 md:pr-6">
      <router-link to="/" class="flex">
        <img
          src="/spyows.png"
          alt="spyows logo"
          style="width:40px; height:40px;"
        />
        <!-- <span class="font-semibold text-xl tracking-tight ml-1">SPYOWS</span> -->
      </router-link>
    </div>
    <div class="block md:hidden pr-6 md:pr-0">
      <button
        @click="isOpen = !isOpen"
        class="flex items-center px-3 py-2 border rounded text-custom border-custom hover:text-white hover:border-white outline-none"
      >
        <svg
          class="fill-current h-3 w-3"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            v-if="!isOpen"
            d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
          />
          <path v-else d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <div
      :class="{ visible: isOpen, hidden: !isOpen }"
      class="bg-black md:bg-transparent md:bg-opacity-75 w-full z-50 block md:flex md:items-center md:w-auto ml-auto px-6 md:pl-0"
    >
      <div
        class="text-md md:flex-grow uppercase font-muli font-semibold text-xs"
      >
        <router-link
          to="/"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          Home
        </router-link>
        <router-link
          to="/about"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          About Us
        </router-link>
        <router-link
          to="/subscribe"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          Subscribe
        </router-link>
        <router-link
          to="/academy"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          Academy
        </router-link>
        <router-link
          to="/testimonials"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          Testimonials
        </router-link>
        <router-link
          to="/login"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          User Login
        </router-link>
        <router-link
          to="/admin-login"
          class="block mt-4 md:inline-block md:mt-0 text-white hover:text-custom mr-3 pl-2 lg:mr-8"
        >
          Admin Login
        </router-link>

        <!-- <dropdown class="block mt-4 md:inline-block md:mt-0 pb-6 md:pb-0"> -->
          <!-- Button content -->
          <!-- <template v-slot:button>
            <span class="mr-2 text-white uppercase inline-block pl-2">EN</span>

            <svg
              class="text-white h-3 w-3 animate-bounce"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M19 9l-7 7-7-7"></path>
            </svg>
          </template> -->

          <!-- Opened dropdown content -->
          <!-- <template v-slot:content>
            <a
              class="block px-4 py-2 text-gray-800 hover:bg-green-500 hover:text-white"
              href="#"
              >English</a
            >
            <a
              class="block px-4 py-2 text-gray-800 hover:bg-green-500 hover:text-white"
              href="#"
              >French</a
            >
            <a
              class="block px-4 py-2 text-gray-800 hover:bg-green-500 hover:text-white"
              href="#"
              >Portugese</a
            >
          </template> -->
        <!-- </dropdown> -->
      </div>
    </div>
  </nav>
</template>

<script>
import Dropdown from "@/components/Dropdown";

export default {
  name: "Nav",
  components: {
    // Dropdown
  },
  data() {
    return {
      isOpen: false
    };
  }
};
</script>
